// recoil
import { atom } from 'recoil';

const TransientDefault = {
    clientCommand: null,
    consoleLog: [],
    account: {
        client: {
            loading: false,
            data: null,
            meta: {},
        },
        server: {
            loading: false,
            data: null,
            meta: {},
        },
        filter: {
            loading: false,
            data: [],
        },
        mlTemplate: {
            loading: false,
            data: [],
        },
    },
    loise: {
        client: {
            loading: false,
            data: null,
            meta: {},
        },
        server: {
            loading: false,
            data: null,
            meta: {},
        },
        filter: {
            loading: false,
            data: [],
        },
        filterOption: {
            loading: false,
            data: [],
        },
        report: {
            loading: false,
            data: [],
        },
        legal: {
            loading: false,
            data: [],
        },
    },
    infrastructure: {
        amis: {},
        regions: [],
        instanceTypes: [],
        awsLaunchTemplates: [],
    },
    internal: {
        error: '',
        warning: '',
        info: '',
        success: '',
        mute: true,
    },
    main: {
        containers: [],
    },
    path: {
        gateway: 'login',
        settingAccount: '/',
    },
    serverCommand: null,
    userSession: null,
};

const TransientState = atom({
    key: 'TransientState',
    default: TransientDefault,
});

export { TransientState };
